<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"/>

      <basic-table
        @Filtred="Filtred"
        :items="internalTransfer"
        :fields="internalTransferFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        limit: 500,
        download: 0
      },
      internalTransfer: [],
      internalTransferFields: [
        {key: 'account_id_from', label: this.$i18n.t('From account ID'), sortable: true},
        {key: 'account_id_to', label: this.$i18n.t('To account ID'), sortable: true},
        {key: 'amount',
          label: this.$i18n.t('Volume'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'date', label: this.$i18n.t('Date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClink = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (this.userId) {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_INTERNAL_TRANSFER', this.getStore).then(response => {
        if (isGenerateClink) {
          this.internalTransfer = this.$store.getters['Reports/INTERNAL_TRANSFER']
        } else {
          download(this.$store.getters['Reports/INTERNAL_TRANSFER'], 'report_payments_funds_flow.csv', 'text/csv')
        }

        this.loadDone()
      })
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_PAYMENTS')
      this.getStore.download = 0
      this.totalRows = 0
      this.internalTransfer = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/internalTransfer/main.vue